import { Component, EventEmitter, Input, Output } from '@angular/core';
import { OrganizationDTO } from '../../../organization/dto/OrganizationDTO';
import { ButtonComponent } from '../buttons/button.component';

@Component({
  selector: 'app-organization-info-card',
  templateUrl: './organization-info-card.component.html',
  styleUrls: ['./organization-info-card.component.scss'],
  imports: [
    ButtonComponent,
  ],
})
export class OrganizationInfoCardComponent {

  @Input() organization: OrganizationDTO;
  @Input() isAbleToManageUsers = false;
  @Input() isOrgAdmin = false;
  @Output() editOrg = new EventEmitter<OrganizationDTO>();
  @Output() inviteMember = new EventEmitter<void>();

  errorImageLink = ERROR_IMAGE_LINK;

  goToOrgWebSite(): void {
    if (!this.organization.webSiteLink.includes('http')) {
      this.organization.webSiteLink = 'https://' + this.organization.webSiteLink;
    }
    window.open(this.organization.webSiteLink);
  }

  onInviteMember(): void {
    this.inviteMember.emit();
  }
}
export const ERROR_IMAGE_LINK = 'https://servcfilesystem.s3.eu-central-1.amazonaws.com/forDevs/147f3e00-4d65-43f1-83f5-1f10ac484325.jfif';
